export default "__VITE_ASSET__B8QSG$4k__"